"use strict";import{tag as r}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const LayersIcon=({width:a=24,height:e=24,hidden:t=!1,title:l="Layers"}={})=>r`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${a}
    height=${e}
    viewBox="0 0 36 36"
    aria-hidden=${t?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label=${l}
  >
    <path
      d="m28.288 19.938-9.839 6.827a.788.788 0 0 1-.898 0l-9.839-6.827L1.858 24a.25.25 0 0 0 0 .41l15.85 10.999a.512.512 0 0 0 .584 0l15.85-10.998a.25.25 0 0 0 0-.41Z"
    />
    <path
      d="M17.699 22.988 1.858 11.996a.25.25 0 0 1 0-.41L17.698.594a.529.529 0 0 1 .603 0l15.841 10.992a.25.25 0 0 1 0 .41l-15.84 10.992a.529.529 0 0 1-.603 0Z"
    />
  </svg>`;
//# sourceMappingURL=Layers.js.map
